"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'accountGrade.preview.title': 'Dettagli Pacchetto Prezzo',
    'accountGrade.preview.back': 'Torna ai Pacchetti Prezzo',
    'accountGrade.preview.edit': 'Modifica Pacchetto Prezzo',
    'accountGrade.preview.delete': 'Elimina Pacchetto Prezzo',
    'accountGrade.preview.enabled': 'Abilitato',
    'accountGrade.preview.disabled': 'Disabilitato',
    'accountGrade.preview.no_data': 'Nessun dato pacchetto prezzo disponibile',
    'accountGrade.preview.error.load_failed': 'Errore nel caricamento del pacchetto prezzo per anteprima',
    'accountGrade.preview.unnamed': 'Pacchetto Prezzo Senza Nome',
    'accountGrade.preview.no_description': 'Nessuna descrizione fornita',
    'accountGrade.preview.price': 'Prezzo mensile',
    'accountGrade.preview.free': 'Gratuito',
    'accountGrade.preview.cents': 'centesimi',
};
